import React from 'react';
import ReactModal from 'react-modal';
import { config } from '../_helpers';
import PropTypes from 'prop-types';

// Ensure ReactModal app element is set
if (typeof document !== 'undefined') {
  ReactModal.setAppElement('#app');
}

const EmailManifestModal = ({
  isOpen,
  onClose,
  dispatchMailList = [],
  mailList = [],
  searchList = [],
  hideSearch = 'hide',
  mailSearchKeyword = '',
  validManifestMail = false,
  onEmailChange,
  onAddEmail,
  onRemoveEmail,
  onRemoveDispatchEmail,
  onSendEmail,
  emailLoader = false,
  buttonText = 'Send Email',
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      onClose={onClose}
      contentLabel='Minimal Modal Example'
      overlayClassName='emailManifestPopup'
    >
      <div id='statusPopup' className='popupModal'>
        <div className='modal-head'>
          <h4 className='modal-title'>Email Manifest & Fire Cards</h4>
          <img
            alt='close'
            className='closeModal'
            onClick={onClose}
            src={require('../assets/images/close_green.png').default}
          />
        </div>

        <div className='modal-body'>
          <div className='mail_div'>
            <div className='left'>
              <input
                type='text'
                className='txtSearchManiEmployees'
                id='txtSearchManiEmployees'
                name='keyword'
                value={mailSearchKeyword}
                placeholder='Search and add employees for sending email...'
                onChange={onEmailChange}
                autoComplete='off'
              />
              {validManifestMail && searchList.length === 0 && (
                <button className='button add_mail' onClick={onAddEmail}>
                  Add Email
                </button>
              )}
              <ul className={'searchResultUl ' + hideSearch}>{searchList}</ul>
            </div>

            <div className='clearFix' />
            <div className='mail-maifest-wrapper'>
              <div className='mail-manifest wrapper'>
                <div className='head'>
                  <div className='emp'>Employee</div>
                  <div className='name'>Name</div>
                  <div className='email'>Email</div>
                  <div className='close' />
                </div>
                {dispatchMailList.map((item, index) => {
                  return (
                    <div key={item} className='employee employee_item'>
                      <div className='pic image-holder'>
                        <img
                          src={config.apiUrl + '/' + config.altImg}
                          onError={(e) => {
                            e.target.setAttribute(
                              'src',
                              config.apiUrl + '/' + config.altImg,
                            );
                          }}
                        />
                      </div>
                      <div className='name'>
                        <span className=''>Dispatch Email</span>
                      </div>
                      <div className='email'>{item}</div>
                      <div
                        className='close-btn'
                        onClick={() => onRemoveDispatchEmail(index)}
                      >
                        <img
                          alt='close'
                          src={
                            require('../assets/images/close_button.png').default
                          }
                        />
                      </div>
                    </div>
                  );
                })}
                {mailList.map((item, index) => {
                  return (
                    <div key={item.email} className='employee employee_item'>
                      <div className='pic image-holder'>
                        <img
                          alt={item.first_name + ' ' + item.last_name}
                          className={item.active}
                          src={
                            item.profile_photo
                              ? config.apiUrl + '/' + item.profile_photo
                              : config.apiUrl + '/' + config.altImg
                          }
                          onError={(e) => {
                            e.target.setAttribute(
                              'src',
                              config.apiUrl + '/' + config.altImg,
                            );
                          }}
                        />
                      </div>
                      <div className='name'>
                        <span className=''>
                          <span className={item.colorcode + ' color_code'} />
                          {item.first_name + ' ' + item.last_name}
                        </span>
                      </div>
                      <div className='email'>{item.email}</div>
                      <div
                        className='close-btn'
                        onClick={() => onRemoveEmail(index)}
                      >
                        <img
                          alt='close'
                          src={
                            require('../assets/images/close_button.png').default
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <p className='sig_message'>
              This email will automatically be sent to the Dispatch email as
              well.
            </p>
            <br />
            <button
              className='button send_mail'
              onClick={onSendEmail}
              disabled={emailLoader}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    </ReactModal>
  );
};

EmailManifestModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  dispatchMailList: PropTypes.array,
  mailList: PropTypes.array,
  searchList: PropTypes.array,
  hideSearch: PropTypes.string,
  mailSearchKeyword: PropTypes.string,
  validManifestMail: PropTypes.bool,
  onEmailChange: PropTypes.func.isRequired,
  onAddEmail: PropTypes.func.isRequired,
  onRemoveEmail: PropTypes.func.isRequired,
  onRemoveDispatchEmail: PropTypes.func.isRequired,
  onSendEmail: PropTypes.func.isRequired,
  emailLoader: PropTypes.bool,
  buttonText: PropTypes.string,
};

export default EmailManifestModal;

